module.exports = "/assets/c32166097db0cc2aa6327989b8488b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/NI.png
// module id = 1648
// module chunks = 0